export default "__VITE_ASSET__0ee8b7fd__"